<template>
  <div>
    <div class="header">
      <div style="width: 20rem"></div>
      <div
        style="width: 2rem"
        v-for="role in roles"
        :key="role.id">
        {{ role.name }}
      </div>
    </div>
    <div
      v-for="item in menuItems"
      :key="item.id"
      class="row">
      <div style="width: 20rem">{{ item.name }}</div>
      <div
        v-for="role in roles"
        :key="item.id + '-' + role.id"
        @click="toggleRole(item.id, role.id)"
        :class="[
          'square',
          { filled: item.roles.map(v => v.roleId).includes(role.id) },
        ]"
        :title="item.name + ' / ' + role.name"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItemRoles',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    menuItems() {
      return this.$store.getters['menu/menuRoles'].item1;
    },
    roles() {
      return this.$store.getters['menu/menuRoles'].item2;
    },
  },
  mounted() {
    this.$store.dispatch('menu/getRoles');
  },
  methods: {
    toggleRole(menuitem, role) {
      this.$store.dispatch('menu/patchRoles', {
        menuItem: menuitem,
        role: role,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  writing-mode: vertical-lr;
  flex-direction: column;
}
.row {
  display: flex;
}
.square {
  width: 2rem;
  height: 2rem;
  border: 1px solid black;
  cursor: pointer;
}
.filled {
  background-color: #555;
}
</style>
